// import { MetaObject } from 'nuxt/dist/head/runtime'

const isDev = process.env.NODE_ENV === 'development'

interface SEOData {
  title: string
  desc?: string
  image?: string
  type?: string
}

export function useSEO() {
  const domain = useState('domain', () => isDev ? 'http://localhost:3000' : 'https://crappyquizchamps.com')
  const route = useRoute()

  const image = 'https://crappyquizchamps.com/images/og-image.png'

  if (process.server) {
    const { ssrContext } = useNuxtApp()

    const host = ssrContext?.req?.headers?.host
    const protocol = ssrContext?.req?.headers?.referer?.split('/')?.[0]

    if (host) {
      if (!protocol) {
        domain.value = `https://${host}`
      }
      else {
        domain.value = `${protocol}//${host}`
      }
    }
  }

  // @ts-ignore
  function GenerateTags(data: SEOData) {
    const title = `${data.title} | Crappy Quiz Stats`
    let canonical
    let alternative
    if (route.fullPath !== '/') {
      canonical = `${domain.value}${route.fullPath}`
      alternative = `${domain.value}${route.fullPath}`
    }
    else {
      canonical = `${domain.value}`
      alternative = `${domain.value}`
    }
    if (route.fullPath !== `/champs/year/${new Date().getFullYear()}`) {
      canonical = `${domain.value}${route.fullPath}`
    }
    else {
      alternative = `${domain.value}`
    }

    const link = [
      { rel: 'canonical', href: canonical, hreflang: 'en' },
      // { rel: 'alternate', href: alternative, hreflang: 'en' },
    ]

    const opengraph = [
      { key: 'og:url', property: 'og:url', content: canonical },
      { key: 'og:locale', property: 'og:locale', content: 'en_gb' },
      { key: 'og:type', property: 'og:type', content: data.type || 'website' },
      { key: 'og:title', property: 'og:title', content: title },
      { key: 'og:description', property: 'og:description', content: data.desc },
      {
        key: 'og:site_name',
        property: 'og:site_name',
        content: 'Crappy Quiz Stats',
      },
      { key: 'og:image:alt', property: 'og:image:alt', content: title },
      {
        key: 'og:image',
        property: 'og:image',
        content: data.image || image,
      },
      { name: 'description', property: 'description', content: data.desc },
    ]

    const twitter = [
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:site',
        content: 'https://crappyquizchamps.com',
      },
      {
        name: 'twitter:creator',
        content: '@CrappyQuizStats',
      },
      { name: 'twitter:title', content: title },
      {
        name: 'twitter:description',
        content: data.desc,
      },
      {
        name: 'twitter:image',
        content: data.image || image,
      },
      {
        name: 'twitter:summary_large_image',
        content: data.image || image,
      },
      {
        key: 'twitter:image:alt',
        property: 'twitter:image:alt',
        content: title,
      },
    ]

    useHead({
      title,
      link,
      meta: [
        {
          key: 'og:description',
          property: 'og:description',
          content: data.desc,
        },
        ...opengraph,
        ...twitter,
      ],
    })
  }

  return { GenerateTags }
}
